"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#004864"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m8.67 2.81a2.08 2.08 0 0 0 -2.08 2.07c0 1.1 1.89 4 2 4.08a.11.11 0 0 0 .08.04.11.11 0 0 0 .1 0c.08-.12 2-3 2-4.08a2.07 2.07 0 0 0 -2.1-2.11zm0 3a.91.91 0 1 1 .9-.9.9.9 0 0 1 -.9.87z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m3.3 11.3a3.3 3.3 0 0 0 -3.3 3.3c0 1.75 3 6.31 3.13 6.5a.19.19 0 0 0 .17.09.2.2 0 0 0 .17-.09c.13-.19 3.12-4.75 3.12-6.5a3.3 3.3 0 0 0 -3.29-3.3zm0 4.7a1.44 1.44 0 1 1 1.44-1.4 1.45 1.45 0 0 1 -1.44 1.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m21.24 7.23a2.77 2.77 0 0 0 -2.76 2.77c0 1.46 2.51 5.28 2.61 5.44a.19.19 0 0 0 .15.08.16.16 0 0 0 .14-.08c.11-.16 2.62-4 2.62-5.44a2.77 2.77 0 0 0 -2.76-2.77zm0 4a1.21 1.21 0 1 1 1.21-1.23 1.21 1.21 0 0 1 -1.21 1.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m16.55 10.61a.5.5 0 0 1 -.26-.08l-4.72-3.15a.47.47 0 0 1 -.13-.66.49.49 0 0 1 .67-.14l4.71 3.15a.48.48 0 0 1 -.27.88z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m7.65 17.37a.48.48 0 0 1 -.44-.28.49.49 0 0 1 .23-.64l9.56-4.45a.49.49 0 0 1 .64.24.47.47 0 0 1 -.23.63l-9.56 4.46a.51.51 0 0 1 -.2.04z"
  })));
};

exports["default"] = _default;